import { useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"

import {
    SPEEDINGS_DEFAULT_ACTIVE_LAYER,
    SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER,
    SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER,
} from "../constants/urlParams"
import { useSpeedingsStateContext } from "../contexts/SpeedingsContext"
import { getSpeedingsLegendConfig } from "../utils/getSpeedingsConfig"
import { getTrafficLegendConfig } from "../utils/getTrafficConfig"

export function useSpeedingsLegend() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()
    const { currentActiveLayer } = useSpeedingsStateContext()

    const speedingsLegends = useMemo(() => {
        return [
            {
                layerName: SPEEDINGS_DEFAULT_ACTIVE_LAYER,
                legendData: getSpeedingsLegendConfig(t, theme),
                title: t(I18N_NAMESPACE, "containers.speedings.legend.title"),
            },
            {
                layerName: SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER,
                legendData: getTrafficLegendConfig(SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER, t, theme),
                title: t(I18N_NAMESPACE, "containers.lightTraffic.legend.title"),
            },
            {
                layerName: SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER,
                legendData: getTrafficLegendConfig(SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER, t, theme),
                title: t(I18N_NAMESPACE, "containers.heavyTraffic.legend.title"),
            },
        ]
    }, [t, theme])

    return [speedingsLegends.find((legend) => legend.layerName === currentActiveLayer) ?? speedingsLegends[0]]
}